'use client';

import { useCallback, useMemo } from 'react';
import { Button } from '../../ui/button';
import MaterialIcons from '@/components/MaterialIcons/materialIcons';
import { getSamlLoginUrl } from '@/lib/auth/idp-urls';
import { getReturnToPath } from '@/utils/auth/common/auth-storage';

/**
 * Owns the SAML/partner redirect itself — the only place navigating via getSamlLoginUrl(),
 * so it can't race LoginModal's old duplicate onPartnerLogin path.
 */
export function PartnerLoginSection() {
  // Env-derived fallback href, no returnTo — stable across renders.
  const fallbackHref = useMemo(() => getSamlLoginUrl(), []);

  // returnTo is added on click, not baked into the href, to avoid an SSR hydration mismatch;
  // middle-click still works, just lands on the root.
  const handleClick = useCallback((event: React.MouseEvent<HTMLAnchorElement>) => {
    const returnTo = getReturnToPath();
    if (returnTo) {
      event.preventDefault();
      window.location.href = getSamlLoginUrl(returnTo);
    }
  }, []);

  return (
    <div className="text-center flex flex-col gap-2">
      <div className="type-s-body-light my-0 text-sm text-text-default-medium">
        Access exclusive partner enablement content, certifications, and tools tailored to help you deliver more value with Contentstack.
      </div>
      <hr className="w-full border-border-medium" />
      <Button
        asChild
        variant="PrimaryFillButton"
        className="w-full flex items-center justify-center gap-2 min-h-[44px] touch-manipulation mt-2"
      >
        <a href={fallbackHref} onClick={handleClick}>
          Log In As Partner
          <MaterialIcons iconName="arrow_right_alt" className="!text-[20px] flex-shrink-0 leading-none transition-transform duration-300 ease-in-out group-hover:translate-x-1" />
        </a>
      </Button>
    </div>
  );
}

